import { AGENT_MODES, DEFAULT_AGENT_MODE, type AgentMode } from '@/features/chat/useChat';

// Which agents this user's TENANT may use. It's a Descope tenant custom attribute
// (`allowedModels`) exposed as a custom claim, so it rides in the session token —
// no endpoint, no table, nothing to keep in sync, and it's already signed.
//
// ⚠ This only decides what RENDERS. The client can ask for anything, so the same
// list is re-checked server-side on /api/message/stream (403 for an agent the
// tenant doesn't have) — see server/auth/web_auth.py `_allowed_models`.

/** The agents in the claim, or just the default agent. Mirrors the server's
 *  `_allowed_models`: the value is typed by hand per tenant in the Descope
 *  console, so accept an array or one comma-separated string, at the top level or
 *  nested under `nsCustomClaims`, and drop anything that isn't a known agent. */
export function parseAllowedModels(claims: unknown): AgentMode[] {
  const c = (claims ?? {}) as Record<string, unknown>;
  const ns = (c.nsCustomClaims ?? {}) as Record<string, unknown>;
  const raw = c.allowedModels ?? ns.allowedModels;
  const parts: unknown[] = typeof raw === 'string' ? raw.split(',') : Array.isArray(raw) ? raw : [];
  const models = parts
    .map((p) => String(p).trim())
    .filter((p): p is AgentMode => (AGENT_MODES as readonly string[]).includes(p));
  // Never nothing (that would hide chat itself) and never more than the claim grants.
  return models.length ? models : [DEFAULT_AGENT_MODE];
}
